import React from 'react';
import PageLayout from '../components/PageLayout';
import Contact from '../components/Contact';
import usePageMeta from '../hooks/usePageMeta';

export default function ContactPage() {
  usePageMeta(
    'Contact Us | Hotel Respiro — São Vicente, Cabo Verde',
    'Contact Hotel Respiro in Baía João Évora, Mindelo, São Vicente, Cabo Verde. Reservations and enquiries: info@hotelrespiro.com.'
  );

  return (
    <PageLayout>
      <div data-testid="contact-page">
        <Contact />
      </div>
    </PageLayout>
  );
}
